module.exports = __webpack_public_path__ + "static/img/addlocalfun.f125db4.png";